import { Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import {
  constants,
} from 'cng-web-lib'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants

function makeValidationSchema(translate) {
  let requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )
  let dateTypeErrorMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.DATE_TYPE_ERROR
  )

  return Yup.object({
    id: Yup.string(),
    h2hId: Yup.string(),
    poNumber: Yup.string(),
    wallmartItemNo: Yup.string(),
    fileType: Yup.string(),
    processStatus: Yup.string(),
    receivedDate: Yup.date().validFormat().typeError(dateTypeErrorMessage),
    receivedFileName: Yup.string(),
    acknowledgedFileName: Yup.string(),
    rejErrMsg: Yup.string(),
  })
}

export default makeValidationSchema
